<p-dialog
        [(visible)]="visible"
        [dismissableMask]="false"
        modal="true"
        [styleClass]="'col-3 height-half'"
        [closable]="false"
        (onHide)="closeDialog()"
        (onShow)="onShow()"
        appendTo="body"
>
    <div class="mb-4 text-center font-bold text-2xl">
        {{ message }}
    </div>
    <div class="col-12 text-center">
        <button type="button" pButton class="margin p-button-primary p-button-outlined" (click)="closeDialog()" label="{{'Close' | translate}}"></button>
        @if (showExecuteButton) {
            <button type="button" pButton class="margin p-button-primary" (click)="execute()" label="{{'Srch' | translate}}"></button>
        }
    </div>
</p-dialog>